import { render } from "./ModalPasswordReset.vue?vue&type=template&id=389de206"
import script from "./ModalPasswordReset.vue?vue&type=script&lang=js"
export * from "./ModalPasswordReset.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mac/Projects/webshop/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__